import { ExperiencePurchaseItem } from "./ExperiencePurchaseItem";
import { MerchandiseFulfillmentPolicy, MerchandiseFulfillmentStatus } from "./Merchandise";
import { PurchaseItemObject } from "./PurchaseItemObject";

export enum FulfillmentUnitStatus {
    RESERVED = "reserved",
    PROCESSING_FULFILLMENT = "processing_fulfillment",
    FULFILLED = "fulfilled",
    RETURNED = "returned",
    DAMAGED = "damaged",
}

export interface FulfillmentUnit {
    id: ID;
    status: FulfillmentUnitStatus;
    unit: { id: ID };
    template: { id: ID };
    inventoryLot?: { id: ID };
    returnReason?: string;
}

export interface MerchandisePurchaseItem
    extends Omit<
        ExperiencePurchaseItem,
        | "arrivalDate"
        | "arrivalTime"
        | "arrivalDateTime"
        | "timeslot"
        | "timeslotUnit"
        | "object"
    > {
    object: PurchaseItemObject.WARE;
    fulfillmentPolicy?: MerchandiseFulfillmentPolicy;
    fulfillmentStatus?: MerchandiseFulfillmentStatus;
    fulfillmentUnits?: FulfillmentUnit[];
}
